<template>
    <div class="bank-reconciliation-column-header">
        <span class="g-title-tabela">
            <i :class="icon"></i>
            {{ title }}
            <span class="badge badge-round badge-round-dark-primary">{{ count }}</span>
        </span>
        <div class="bank-reconciliation-column-header-total">
            <div class="bank-reconciliation-column-header-total-label">Total</div>
            <div class="bank-reconciliation-column-header-total-value"
                :class="{ 'bank-reconciliation-column-header-total-value-positive': total > 0, 'bank-reconciliation-column-header-total-value-negative': total < 0 }">
                {{ total | currency }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BankReconciliationColumnHeader",
    props: {
        title: {
            type: String,
            default: "",
        },
        icon: {
            type: String,
            default: "",
        },
        count: {
            type: Number,
            default: 0,
        },
        total: {
            type: Number,
            default: 0,
        },
    },
};
</script>

<style scoped>
.bank-reconciliation-column-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
    flex-shrink: 0;
    width: 100%;
}

.bank-reconciliation-column-header-total {
    text-align: right;
}

.bank-reconciliation-column-header-total-label {
    font-size: 10.5px;
    font-weight: 700;
    text-transform: uppercase;
    color: var(--text-muted);
}

.bank-reconciliation-column-header-total-value {
    font-size: 14px;
    font-weight: 700;
    color: var(--text-primary);
}

.bank-reconciliation-column-header-total-value-positive {
    color: var(--color-success);
}

.bank-reconciliation-column-header-total-value-negative {
    color: var(--color-danger);
}
</style>
